export const THRED_ROLE = {
  auth0RoleName: 'Thred-Dev',
  alias: 'Thred User',
} as const;

export const THRED_ROLES_AUTH_NAME = [THRED_ROLE.auth0RoleName];
